import { render, staticRenderFns } from "./LeavesAdd.vue?vue&type=template&id=86ac1dd4&"
import script from "./LeavesAdd.vue?vue&type=script&lang=js&"
export * from "./LeavesAdd.vue?vue&type=script&lang=js&"
import style0 from "./LeavesAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports